export default defineNuxtRouteMiddleware(async (to) => {
  const { user, loggedIn, clear } = useUserSession()
  const nuxtApp = useNuxtApp()
  const locale = nuxtApp.$i18n.locale.value
  const byhoursConnect = useCookie('byhours_connect')

  // Si el usuario no está logueado y va a una página de user-zone, redirigir a login
  if (!user.value && to.path.includes('/user-zone')) {
    return navigateTo(`/${locale}/login`)
  }

  // Si el usuario está logueado y va a la página de login, redirigir a user-zone
  if(user.value && to.path.includes('/login')) {
    return navigateTo(`/${locale}/user-zone`)
  }

  // Si no hay token y no está logueado, eliminar cookie de nuxt-session y redirigir a login
  if (loggedIn.value && !byhoursConnect.value) {
    await clear()
    return navigateTo(`/${locale}`)
  }

})